'use strict';
var Papa = require('papaparse'); // TODO(npm): may need to install with NPM?

module.exports = [
  papaParseFactory];

// Provides an adapter for injecting papa parse into services.
function papaParseFactory() {
  return Papa;
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/papaParse/papaParse.js